import { render } from "./TotpSetupModal.vue?vue&type=template&id=afc3fdbc&scoped=true"
import script from "./TotpSetupModal.vue?vue&type=script&lang=js"
export * from "./TotpSetupModal.vue?vue&type=script&lang=js"

import "./TotpSetupModal.vue?vue&type=style&index=0&id=afc3fdbc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afc3fdbc"]])

export default __exports__